<template>
  <div class="addGoodsWrapper">
    <div class="center">
      <div class="baseInfo">
        <div class="leftTesc">
          <div style="width:100%;" class="yhjv">
            <el-table size="mini" :span-method="objectSpanMethod" :data="dataList" border>
              <el-table-column
                v-for="(item,index) in itemList"
                :key="index"
                :label="item.desc"
              >
                <template  slot-scope="props">
                  <span v-if="item.type == 'image'" class="imageMain"><img :src="props.row[item.key]" /></span>
                  <span v-if="item.type == 'default'">{{props.row[item.key]}}</span>
                  <span v-if="item.type == 'input'">
                  <el-input size="mini" v-model="props.row[item.key]" placeholder=""></el-input>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TABLE_ITEMS } from "./const/const";
export default {
  data() {
    return {
      goodList: [],
      itemList: TABLE_ITEMS
    };
  },
  computed: {
    itemListCopy(){
      return this.itemList.filter(item => {
        return item.default
      }) 
    },
  },
  props: {
    dataList: {
      type: Array,
      default: () => {}
    }
  },
  watch: {},
  created() {},
  methods: {
    showHeader(h, { column, $index }){
      console.log('column',column)
      return h('div', {id: 'h-id'}, [
      h('div', {}, ['1月']),
      h('span', {}, ['卓越值']),
      h('span', {}, ['标准值']),
      h('span', {}, ['警戒值'])
    ])
      
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (row.rowSpan >= 1) {
          return {
            rowspan: row.rowSpan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    updateModel(){
      this.$emit('updateTemple',this.dataList)
    },
  }
};
</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";
.addGoodsWrapper {
  position: relative;

  .center {
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 1248px;
    font-size: 12px;
    height: calc(100vh - 50px);
    .imageMain{
      display: inline-block;
      width: 120px;

      img{
        width: 100%;
      }

    }

    .baseInfo {
      margin-top: 20px;

      .title {
        font-size: 18px;
        color: rgba(0, 0, 0, 0.8);
        font-weight: bold;
      }

      .yhjv {
        margin: 10px;
        background-color: #fff;
        box-sizing: border-box;
      }

      .leftTesc {
        display: flex;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.8);
      }
    }
  }
}
</style>